import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button, Form, PasswordInput, InlineNotification } from '@carbon/react';
import { useAuthActions } from 'src/hooks/useAuthActions';

const ResetPassword = () => {
  const { t } = useTranslation('authentication');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const { resetPassword, isPending, error } = useAuthActions();
  const [form, setForm] = useState({ password: '', confirm: '' });
  const [mismatch, setMismatch] = useState(false);

  if (!token) {
    return (
      <div className="cds--auth__form">
        <h1>{t('resetPassword.title')}</h1>
        <InlineNotification kind="error" title={t('resetPassword.missingToken')} lowContrast hideCloseButton />
      </div>
    );
  }

  async function onSubmit(event: React.FormEvent) {
    event.preventDefault();
    const activeToken = token;
    if (!activeToken) {
      return;
    }
    if (form.password !== form.confirm) {
      setMismatch(true);
      return;
    }
    const result = await resetPassword(form.password, activeToken);
    if (result) {
      navigate('/sign-in', { replace: true });
    }
  }

  return (
    <Form onSubmit={onSubmit} className="cds--auth__form">
      <h1>{t('resetPassword.title')}</h1>
      {error && <InlineNotification kind="error" title={error.message} lowContrast hideCloseButton />}
      {mismatch && <InlineNotification kind="error" title={t('resetPassword.mismatch')} lowContrast hideCloseButton />}
      <PasswordInput
        id="password"
        labelText={t('resetPassword.password')}
        value={form.password}
        onChange={(e) => {
          setMismatch(false);
          setForm({ ...form, password: e.target.value });
        }}
        required
      />
      <PasswordInput
        id="confirm"
        labelText={t('resetPassword.confirm')}
        value={form.confirm}
        onChange={(e) => {
          setMismatch(false);
          setForm({ ...form, confirm: e.target.value });
        }}
        required
      />
      <Button type="submit" disabled={isPending}>
        {t('resetPassword.submit')}
      </Button>
    </Form>
  );
};

export default ResetPassword;
